import moment from 'moment';
import { DATE_FORMAT, MIN_DATE } from '@/consts';

import {
  APPLY_FILTERS,
  CLEAR_FILTERS,
  SET_ITEMS,
  FILTER_ITEMS,
  SET_APPEND,
  SET_LOADING,
  SET_ASSET_DETAIL
} from './types';

export const INIT_STATE = {
  filters: {
    term: '',
    page: 1,
    pageSize: 30,
    branch: null,
    fromDate: null,
    toDate: null,
  },
  items: [],
  storedItems: [],
  total: 0,
  isLoading: false,
  isAppending: false,
  targetingAsset: {}
};

const mutations = {
  [APPLY_FILTERS](state, filters) {
    state.filters = {
      ...state.filters,
      ...filters
    };
  },

  [SET_APPEND](state, val) {
    state.isAppending = val || false;
  },

  [SET_LOADING](state, val) {
    state.isLoading = val || false;
  },

  [CLEAR_FILTERS](state) {
    state.filters = {
      ...INIT_STATE.filters
    };
  },
  [SET_ITEMS](state, { items, total }) {
    if (state.isAppending) {
      state.items = [
        ...items,
        ...state.items
      ];
    } else {
      state.items = [...items];
    }

    state.items = items;
    state.total = total;
  },

  [FILTER_ITEMS](state) {
    const { branch } = state.filters;
    let items = [...state.items];

    if (branch) {
      items = items.filter((item) => (branch.indexOf(item.branch?.id) >= 0));
    }

    state.items = items;
  },

  [SET_ASSET_DETAIL](state, result) {
    state.targetingAsset = { ...result };
  }

};

export default mutations;
